import React from "react";
import { Badge } from "reactstrap";
import { serviceCaller } from "../../../../composition";
import styles from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import { Props, Segment } from "./types";

const SegmentPills = ({
  segments,
  selectedSegments,
  setSelectedSegments,
  allowEdit,
}: Props) => {
  const handleSegmentClick = (segment: Segment) => {
    if (!allowEdit) return;
    const newSegments = selectedSegments.includes(segment)
      ? selectedSegments.filter(t => t !== segment)
      : [...selectedSegments, segment];
    setSelectedSegments(newSegments);
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        maxHeight: "200px",
        overflow: "scroll",
      }}
    >
      <Badge
        key={"all"}
        color="light"
        className={`${styles.basePill} ${
          segments.length === selectedSegments.length
            ? styles.selectedPill
            : styles.inactivePill
        }`}
        onClick={() =>
          setSelectedSegments(
            segments.length === selectedSegments.length ? [] : segments
          )
        }
        pill
      >
        All
      </Badge>
      {segments.map(segment => {
        const isIncluded = selectedSegments.includes(segment);
        return (
          <Badge
            key={segment.id}
            className={`${styles.basePill} ${
              isIncluded ? styles.selectedPill : styles.inactivePill
            }`}
            onClick={() => handleSegmentClick(segment)}
            pill
          >
            {segment.name}
          </Badge>
        );
      })}
    </div>
  );
};

export default serviceCaller(withStyles(styles)(SegmentPills));
